@if (hasShopItems) {
  <div class="free__shipping" [class.free__shipping___AB344]="ab344Configuration().isAB344Active">
    <span>{{ 'txt-shipping' | translate }}</span>
    <div>
      @if (ab344Configuration().isAB344Active) {
        <span class="free__discountText">$15</span>
      }
      <span class="free">
        {{ ab344Configuration().shippingPriceText }}
      </span>
    </div>
  </div>
}

@if (!!cart?.totalTax) {
  <div class="free__shipping">
    <span>{{ 'txt-estimated-tax' | translate }}</span>
    <span>{{ cart.totalTax | localize }}</span>
  </div>
}

<div class="cart__price">
  <span>{{ 'txt-total' | translate }}</span>
  <span>{{ cart.totalPrice | localize }}</span>
</div>

@if (showOuraDiscountBannerAB364()) {
  <div class="ouraBanner">
    <div class="ouraBanner__content">
      <div class="ouraBanner__text">
        <span class="ouraBanner__title">
          10% discount off Oura Ring + <br />
          1 month free membership
        </span>
        <span class="ouraBanner__subTitle"> Link to exclusive offer after payment</span>
      </div>
      <img
        class="ouraBanner__image"
        src="assets/img/ab-433/iphone15-oura-gen4-Illustration-blue.png"
        alt="iPhone 15 with Oura Ring gen4 image"
      />
    </div>
  </div>
}
